import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import {
  ProgressHistoryControllerProgressHistoryQueryParams,
  useDashboardProgressHistoryV1ControllerProgressHistory,
} from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useProgressHistory = ({
  startDate,
  endDate,
  constructionSiteId,
}: ProgressHistoryControllerProgressHistoryQueryParams) => {
  const headers = useRestApiHeaders(Module_Enum.Dashboard);

  const {
    data: progressHistory,
    isFetching,
    error,
  } = useDashboardProgressHistoryV1ControllerProgressHistory({
    queryParams: {
      startDate,
      endDate,
      constructionSiteId,
    },
    headers,
  });

  return { error, loading: isFetching, progressHistory };
};
